<template>
  <div v-if="state.login">
    <DashboardView @change="change"/>
    <section class="vxdash-body" :class="{'mobile vxdash-mobile' : state.mobile}">
      <div class="vxdash-body-in">
        <router-view/>
      </div>
    </section>
  </div>
  <div v-else class="ldr">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>

<script>
import { reactive, computed} from 'vue';
import { useStore } from "vuex";
import { urls } from "@/assets/js/urls";
import DashboardView from "@/components/DashboardView";
export default {
  name: 'App',
  components:{
    DashboardView
  },
  setup(){
    const state=reactive({mobile:false,login:false})
    function change(s){
      state.mobile=s
    }
    const store=useStore();
    const user=computed(()=>store.state.User.user);

    function verifySess(){
      const update = {verifySess: "verifySess"};
      const options = {method: 'POST',headers: {'Content-Type': 'application/json'},credentials:"include", body: JSON.stringify(update)};
      fetch(urls.dashboard, options).then(data => {
          if (!data.ok) {
              throw Error(data);
          }
          return data.json();
      }).then(res => {
        if(!res.session){
          window.location=urls.login;
        }else if(res.redirect){
          window.location=res.redirect;
          return;
        }else{
          var r=res.data.msg
          var user={
            name:r.name,
            username:r.usrid,
            persona:r.persona
          }
          var login={
              status:true,
              auth_code:r.auth_code
            }
          store.dispatch("Login/setLogin",login);
          store.dispatch("User/setUser",user);
          state.login=true;
        }
      }).catch(()=> {
        window.location=urls.login;
      });
    }
    return {
      state, change,user,verifySess
    }
  },
  beforeCreate: function(){
    this.verifySess();
  }
}
</script>
<style>
@import url("./assets/css/vixcss.css");
@import url("./assets/css/fonts.css");
@import url("./assets/css/main.css");
.ldr{display:flex; align-items: center; justify-content:center;
width:100%; height:100vh}
.ldr img{width: 100px}
</style>
